// extracted by mini-css-extract-plugin
module.exports = {"stockAvailability":"index__stockAvailability___3BEcM","title":"index__title___p6iAy","storeSelector":"index__storeSelector___3cuaO","field":"index__field___3l8Ee"};